enum OrderAddViewMode {
  CARGO = "CARGO",
  RAILY = "RAILY",
}

export default OrderAddViewMode;
